export const GRADE_PAGE_SLUGS = {
    GRADE_10: 'grade-10',
    GRADE_11: 'grade-11',
};

export const gradePickerCards = [
    {
        slug: GRADE_PAGE_SLUGS.GRADE_10,
        routeName: 'grade-10',
        title: 'أولى ثانوي',
        badge: 'ابدأ الأساس صح',
        headline: 'افهم التكنولوجيا من البداية… وابقى جاهز للمستقبل',
        text: 'في أولى ثانوي هنساعدك تفهم Programming & AI من الأساس، وتتعامل مع مفاهيم التكنولوجيا والبرمجة بطريقة سهلة وعملية، عشان تدخل تانية ثانوي وأنت سابق بخطوة.',
        points: [
            'تأسيس قوي من البداية',
            'فهم قبل الحفظ',
            'تدريب عملي بسيط',
            'استعداد لتانية ثانوي',
            'بداية طريق المستقبل',
        ],
        cta: 'ادخل صفحة أولى ثانوي',
        theme: 'cyan',
    },
    {
        slug: GRADE_PAGE_SLUGS.GRADE_11,
        routeName: 'grade-11',
        title: 'تانية ثانوي',
        badge: 'استهدف 100/100',
        headline: 'نظام كامل يساعدك تفهم، تطبّق، وتراجع قبل الامتحان',
        text: 'في تانية ثانوي هنمشي معاك بنظام واضح: شرح، تدريب، Coding Lab، Community، Calendar، مراجعات، وامتحانات تدريبية تساعدك تدخل الامتحان بثقة وتستهدف أعلى درجة.',
        points: [
            'شرح المنهج كامل',
            'تدريب على النظري والعملي',
            'Coding Lab',
            'مراجعات وامتحانات',
            'خطة طول السنة',
        ],
        cta: 'ادخل صفحة تانية ثانوي',
        theme: 'green',
    },
];

export function findGradeIdBySlug(appData, slug) {
    const grades = appData && appData.grades ? appData.grades : [];
    if (!grades.length) {
        return null;
    }

    const matchers = {
        [GRADE_PAGE_SLUGS.GRADE_10]: /أولى|اولى|first|grade\s*10|10/i,
        [GRADE_PAGE_SLUGS.GRADE_11]: /تانية|تانيه|second|grade\s*11|11/i,
    };

    const pattern = matchers[slug];
    if (!pattern) {
        return null;
    }

    const match = grades.find((grade) => pattern.test(grade.name || ''));
    return match ? match.id : null;
}

export function gradeCoursesRoute(appData, slug) {
    const gradeId = findGradeIdBySlug(appData, slug);
    if (gradeId) {
        return { name: 'courses', query: { grade_id: String(gradeId) } };
    }
    return { name: 'courses' };
}

export function getGradePickerCard(slug) {
    return gradePickerCards.find((card) => card.slug === slug) || null;
}
